import { createFileRoute } from "@tanstack/react-router";

import { CreateEvaluationWizard } from "@/components/admin/createEvaluation/createEvaluationWizard";

export const Route = createFileRoute("/dashboard/_authenticated/admin/campaigns/create")({
  component: RouteComponent,
  staticData: {
    pageWidth: "wide",
    breadcrumb: ["Create evaluation"],
  },
});

function RouteComponent() {
  return <CreateEvaluationWizard />;
}
